<template>
  <nav id="main-navigation">
    <template v-for="item in menus">
      <router-link
        v-if="!item.external"
        :key="item.slug"
        :to="item.link"
        class="link"
        :class="{ 'dropdown': item.dropdown }">
        <span class="icon">
          <i class="far" :class="item.icon"></i>
        </span>
        <span class="title">
          {{ item.name }}
          <i v-if="item.dropdown" class="far fa-caret-down"></i>
        </span>

        <div v-if="item.dropdown" class="dropdown">
          <router-link
            v-for="dropdownItem in item.dropdown"
            :key="dropdownItem.slug"
            :to="dropdownItem.link"
            class="link">
            <span class="title">
              {{ dropdownItem.name }}
            </span>
          </router-link>
        </div>
      </router-link>

      <a v-else
        :key="item.slug"
        :href="item.link"
        class="link"
        :class="{ 'dropdown': item.dropdown }">
        <span class="icon">
          <i class="far" :class="item.icon"></i>
        </span>
        <span class="title">{{ item.name }}</span>
      </a>
    </template>
  </nav>
</template>

<script>
export default {
  name: 'TheNavigation',

  computed: {
    menus() {
      return [
        {
          name: this.$t('general.types'),
          slug: 'types',
          link: '/products',
          icon: 'fa-border-all',
          external: false,
          dropdown: [
            {
              name: 'Mainstream',
              slug: 'mainstream',
              link: '/products/mainstream',
              icon: '',
              external: false,
            },
            {
              name: 'Premium',
              slug: 'premium',
              link: '/products/premium',
              icon: '',
              external: false,
            },
            {
              name: 'Gaming',
              slug: 'gaming',
              link: '/products/gaming',
              icon: '',
              external: false,
            },
          ],
        },
        {
          name: this.$t('general.finder'),
          slug: 'finder',
          link: '/product-finder',
          icon: 'fa-server',
          external: false,
        },
        {
          name: this.$t('general.compare'),
          slug: 'compare',
          link: '/compare',
          icon: 'fa-bring-forward',
          external: false,
        },
        {
          name: this.$t('general.news'),
          slug: 'news',
          link: 'https://pilihlaptop.com/news',
          icon: 'fa-newspaper',
          external: true,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
  #main-navigation {
    min-width: 28rem;
    width: 55%;
    text-align: right;

    .link {
      position: relative;
      margin-right: 1.5rem;
      text-transform: uppercase;
      vertical-align: middle;
      font-weight: 500;
      font-size: 0;
      color: $grey-dark;

      &.router-link-active {
        color: $black;
        font-weight: 600;
      }

      &:hover {
        .dropdown {
          display: block;
        }
      }

      .dropdown {
        position: absolute;
        top: calc(100% + 0.5rem);
        left: -1rem;
        display: none;
        padding: 1.5rem 1rem 1rem;
        background-color: $white;
        border-radius: 0 0 0.25rem 0.25rem;
        text-align: left;

        .link {
          display: block;
          padding: 0.25rem 0;
        }
      }

      .icon {
        position: relative;
        // top: -1px;
        display: inline-block;
        height: 1.25rem;
        width: 1.25rem;
        margin-right: 0.75rem;
        color: $color-primary;
        vertical-align: middle;

        svg {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .title {
        vertical-align: middle;
        font-size: 0.875rem;
        font-weight: 600;

        svg {
          color: $grey;
          margin-left: 0.5rem;
        }
      }
    }
  }
</style>
